(function () {
    'use strict';

    var vm = require('../../components/agents/Reports');

    var Charter = require('../../modules/Charter');
    var $bookingsByAgents = $('#bookings-by-agents');
    var randomColor = require('randomcolor');

    if ($bookingsByAgents.length > 0) {
        var bookingsByAgents = greenmotion.reports.bookingsByAgents.results.booking;
        var agentsColors = {};
        var tableInitialised = false;

        $.each(bookingsByAgents, function (month, agents) {
            if (!agents || agents.length === 0) {
                return true;
            }

            var $div = $(
                '<div class="col-sm-3 text-center"><canvas data-month="' +
                    month +
                    '"></canvas><span>' +
                    month +
                    '</span></div>'
            ).appendTo($bookingsByAgents);

            var data = $.map(agents, function (agent, key) {
                if (!agentsColors[key]) {
                    agentsColors[key] = randomColor();
                }

                return {
                    value: agent.booking_count,
                    label: agent.name,
                    color: agentsColors[key],
                };
            });

            var chart = Charter.pie($div.children('canvas'), data);

            $div.children('canvas').on('click', function (e) {
                var activePoints = chart.getSegmentsAtEvent(e);

                if (!activePoints[0]) {
                    return;
                }

                var agentName = activePoints[0].label;
                var monthName = $(this).data('month');
                var bookings = [];
                var agents = window.greenmotion.reports.bookingsByAgents.results.booking[monthName];

                for (var index in agents) {
                    var agent = agents[index];

                    if (agent.name === agentName) {
                        bookings = agent.bookings;
                    }
                }

                if (!bookings) {
                    return;
                }

                var bookingsByAgentsComponent = vm.$children[0];

                bookingsByAgentsComponent.agent = agentName;
                bookingsByAgentsComponent.month = monthName;
                bookingsByAgentsComponent.bookings = bookings;
                bookingsByAgentsComponent.viewMode = 'details';

                vm.$nextTick(function () {
                    if (!tableInitialised) {
                        $('.footable-paginated').footable();

                        tableInitialised = true;
                    } else {
                        $('.footable-paginated').trigger('footable_redraw');
                    }
                });
            });
        });
    }
})();
